import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CareerSection } from './components/CareerSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PagePreviewSection } from './components/PagePreviewSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { VideoSection } from './components/VideoSection';
import { ClosingSection } from './components/ClosingSection';
import { SelectablePricingSection } from './components/SelectablePricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ZenAudio } from './components/ZenAudio';
export function App() {
  useEffect(() => {
    const isProduction = window.location.hostname === 'packreiki.ebooksolutions.online';
    if (isProduction && typeof window !== 'undefined' && !(window as any).fbq) {
      const script = document.createElement('script');
      script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','2032586933980278');fbq('track','PageView');`;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2032586933980278&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-[#0f0f1a] text-gray-200" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <HowItWorksSection data-id="element-7" />
        <PagePreviewSection data-id="element-8" />
        <CareerSection data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <BenefitsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <PricingSection data-id="element-14" />
        <VideoSection data-id="element-15" />
        <ClosingSection data-id="element-16" />
        <SelectablePricingSection data-id="element-17" />
        <FAQSection data-id="element-18" />
      </main>
      <Footer data-id="element-19" />
      <SocialProofPopup data-id="element-20" />
      <WhatsAppButton data-id="element-21" />
      <ZenAudio data-id="element-22" />
    </div>;
}